import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d20f766a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { className: "container py-2 py-md-5 min-vh-50" }
const _hoisted_2 = { className: "user-container-body" }
const _hoisted_3 = { class: "reset-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reset-title" }, "👩‍✈️️️ Crea nuova Password", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "me-3"
}, null, -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "passwordConfirm",
  class: "me-3"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"login-subtitle my-4\" data-v-d20f766a><span class=\"reset-subtitle\" data-v-d20f766a>✋ Cliccando questo tasto di seguito prometto di ricordarmi la nuova password</span></div><div class=\"row\" data-v-d20f766a><div class=\"col-12 text-start\" data-v-d20f766a><button type=\"submit\" class=\"btn btn-pc btn-pc-primary\" data-v-d20f766a>Conferma cambio passowrd</button></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                name: "password",
                class: _normalizeClass(["form-control", $setup.status($setup.v.password)]),
                placeholder: "Nuova password",
                "aria-label": "Nuova password",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v.password.$model) = $event)),
                autocomplete: "off"
              }, null, 2), [
                [_vModelText, $setup.v.password.$model]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "passwordConfirm",
                passwordConfirm: "password",
                class: _normalizeClass(["form-control", $setup.status($setup.v.passwordConfirm)]),
                placeholder: "Conferma nuova password",
                "aria-label": "Conferma nuova password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v.passwordConfirm.$model) = $event)),
                autocomplete: "off"
              }, null, 2), [
                [_vModelText, $setup.v.passwordConfirm.$model]
              ])
            ])
          ]),
          _hoisted_11
        ], 32)
      ])
    ])
  ]))
}